// extracted by mini-css-extract-plugin
module.exports = {"pointer":"_1R7DqN","pulsate":"_1DjBK4","brand":"_1NH9i0","icon":"_2_epsR"};